import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { LocalStorageKeys } from 'src/app/core/local-storage/local-storage.enum';
import { LocalStorageService } from 'src/app/core/local-storage/local-storage.service';
import { LocaleEnum } from 'src/app/submit-lecture/lecture.values';
import { UserAdminVerificationStatusEnum, UserValuesData } from 'src/app/users/interfaces/user-values';
import { IUserMetadata } from 'src/app/users/interfaces/user.interface';
import { UserService } from 'src/app/users/services/user.service';


@Component({
  selector: 'leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.scss'],
})

export class LeaderBoardComponent implements OnInit, OnDestroy {
  allUsersMeta: IUserMetadata[] = [];
  isLoading = false;
  currentUser;
  private subscription: Subscription;
  lang: string;
  currentPlace: number;

  constructor(private userService: UserService,
              private authService: AuthService,
              private activeModal: NgbActiveModal,
              private localStorageService: LocalStorageService,
              private readonly translate: TranslateService) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.getAllUsersProgress();
    this.authService.getCurrentUser().then(user => {
      this.currentUser = user;
    });

    const lang: string = this.localStorageService.read(LocalStorageKeys.language) ?? LocaleEnum.HE;
    this.onLangChange(lang);

    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.onLangChange(event.lang);
    });
  }

  private onLangChange(lang): void {
    this.lang = lang;
  }

  closeModal(): void {
    this.activeModal.close();
  }

  isCurrentUser(email): boolean {
    return email === this.currentUser.email;
  }

  private async getAllUsersProgress(): Promise<void> {
    if (this.allUsersMeta?.length === 0) {
      this.isLoading = true;
      this.allUsersMeta = await this.userService.getAllUsersByFilter((ref) =>
        ref.where('adminVerificationStatus', '==', UserAdminVerificationStatusEnum.APPROVED)
          .where('email', '!=', UserValuesData.DEFAULT_USER_EMAIL), true);
      this.allUsersMeta.sort((a, b) => b.progress?.numOfCompleted - a.progress?.numOfCompleted);

      this.isLoading = false;
      this.currentPlace = this.allUsersMeta.findIndex(x => x.email === this.currentUser.email) + 1;
    }
  }
}
